module.exports = __webpack_public_path__ + "f99bdaaf22bc2bc5ddc776e21977da09.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Oval@2x.png
// module id = 322
// module chunks = 0